import ImageWMSEx from "../net/ImageWMSEx";
import ImageLayer from "ol/layer/Image";
import { Map } from "ol";
import { Tile } from "ol/layer";
import { XYZ } from "ol/source";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

export class LayerUtil {
  /**
   * 表示レイヤが存在するか判定
   */
	static isVisibleLayer(_map:Map, _Layer:ImageLayer<ImageWMSEx> | Tile<XYZ> | VectorLayer<VectorSource>){

		const view = _map.getView();
		const resolution = view.getZoom();

		const isVisible = _Layer.getVisible();
		const minRes = _Layer.getMinZoom() ?? 0;
		const maxRes = _Layer.getMaxZoom() ?? Infinity;

		const inZoomRange = resolution > minRes && resolution <= maxRes;
		return isVisible && inZoomRange
	}
}
